/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyMynaHomeWebURLRequestBodyTypename = "PutPharmacyMynaHomeWebURLRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyMynaHomeWebURLRequestBody
 */
export interface PutPharmacyMynaHomeWebURLRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPharmacyMynaHomeWebURLRequestBody
   */
  mynaHomeWebUrl: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyMynaHomeWebURLRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyMynaHomeWebURLRequestBodyFromJSON(json: any): PutPharmacyMynaHomeWebURLRequestBody {
  return PutPharmacyMynaHomeWebURLRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyMynaHomeWebURLRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyMynaHomeWebURLRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyMynaHomeWebURLRequestBodyTypename,

    mynaHomeWebUrl: json["myna_home_web_url"],
  };
}

export function PutPharmacyMynaHomeWebURLRequestBodyToJSON(object?: PutPharmacyMynaHomeWebURLRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    myna_home_web_url: value.mynaHomeWebUrl,
  };
}
